import { getApps, getApp, initializeApp } from 'firebase/app';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import { firebaseCredentials } from 'Api';

const firebaseConfig = {
  apiKey: firebaseCredentials?.apiKey,
  authDomain: firebaseCredentials?.authDomain,
  databaseURL: firebaseCredentials?.databaseURL,
  projectId: firebaseCredentials?.projectId,
  storageBucket: firebaseCredentials?.storageBucket,
  messagingSenderId: firebaseCredentials?.messagingSenderId,
  appId: firebaseCredentials?.appId,
  measurementId: firebaseCredentials?.measurementId,
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Lets the phone-number step and the enter-code step (two separate routed
// pages) share the live confirmationResult object, which can't survive
// sessionStorage/JSON like the rest of the signup state does.
export const phoneAuthSession = { confirmationResult: null };

export const createRecaptchaVerifier = (containerId) => new RecaptchaVerifier(auth, containerId, { size: 'invisible' });

export const sendFirebaseOtp = async (phoneNumberE164, verifier) => {
  const result = await signInWithPhoneNumber(auth, phoneNumberE164, verifier);
  phoneAuthSession.confirmationResult = result;
  return result;
};

export const mapFirebaseAuthError = (error) => {
  switch (error?.code) {
    case 'auth/invalid-phone-number': return 'That phone number doesn\'t look right.';
    case 'auth/too-many-requests': return 'Too many attempts. Please try again later.';
    case 'auth/code-expired': return 'That code expired. Please request a new one.';
    case 'auth/invalid-verification-code': return 'Incorrect code. Please try again.';
    default: return error?.message || 'Oops! Something went wrong';
  }
};
